const locale = {
    placeholder: 'Выберите время',
};
export default locale;
